const transformHubs = (hubs) => {
  return hubs.map((hub) => ({
    label: hub.name,
    value: hub.shortCode,
  }))
}

export default transformHubs
